import React, { ReactElement } from 'react'
import Card from 'ui/atoms/Card/Card'
import { registerDefaultProps, registerUiConfigComponent } from 'ui/uiConfig/factory'
import type { ElplanBidsProps } from './ElplanBids.types'

const defaultProps = {
  use_default: true,
}
registerUiConfigComponent(`elplan_bids`, ElplanBids, {
  isSingletonComponent: true,
})
registerDefaultProps(`elplan_bids`, defaultProps)

export default function ElplanBids({ items, datasets }: ElplanBidsProps): ReactElement {
  return (
    <>
      <Card title="Elplan bids" titleSize="small">
        <p>
          {items.length} items. {datasets.length} datasets.
        </p>

        {datasets.map((dataset, index) => (
          <div key={index}>{dataset.return_id}</div>
        ))}
      </Card>
    </>
  )
}
